var exports = {
  "S": "NameplateBackground.module__image___a3pmQ0",
  "Q": "NameplateBackground.module__content___a3pmQ0",
};

module.exports = exports;
